import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { getStatusColor, convertUnderscoreToSpaces } from "../utils";

/**
 * StatusBadge - A reusable component for displaying status with count
 * @param {string} status - The status value (e.g., "indexed", "pending_review")
 * @param {number} count - The count to display
 * @param {boolean} showLabel - Whether to show the status label - default: true
 * @param {boolean} showCount - Whether to show the count - default: true
 * @param {string} variant - Chip variant ("filled", "outlined") - default: "filled"
 * @param {string} size - Chip size ("small", "medium") - default: "small"
 * @param {object} sx - Additional Material-UI sx props
 * @param {object} ...props - Additional props to pass to the Stack component
 */
const StatusBadge = ({
  status,
  count,
  showLabel = true,
  showCount = true,
  variant = "filled",
  size = "small",
  sx = {},
  ...props
}) => {
  const statusColor = getStatusColor(status);
  const statusLabel = convertUnderscoreToSpaces(status);

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx} {...props}>
      {showLabel && (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {statusLabel}
        </Typography>
      )}
      {showCount && count > 0 && (
        <Chip
          label={count.toLocaleString()}
          size={size}
          color={statusColor}
          variant={variant}
          sx={{
            height: size === "small" ? "20px" : "24px",
            fontSize: size === "small" ? "12px" : "14px",
            fontWeight: 500,
            minWidth: "40px",
          }}
        />
      )}
    </Stack>
  );
};

export default StatusBadge;
